interface FinalCTAProps {
  onEstimateClick: () => void;
  heading?: string;
  subtext?: string;
  showUrgency?: boolean;
}

export default function FinalCTA({
  onEstimateClick,
  heading = 'Upgrade Your Floors Today',
  subtext = 'Get expert hardwood flooring services backed by precision craftsmanship and Maryland\'s most trusted reputation.',
  showUrgency = true,
}: FinalCTAProps) {
  return (
    <section className="relative py-32 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/10628e21e6adfae1b0f111f9b2eace2a.jpg"
          alt="Beautiful hardwood floors Premier Maryland"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-walnut/80 via-walnut/80 to-walnut/90" />
      </div>

      <div className="relative max-w-3xl mx-auto text-center">
        {showUrgency && (
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-5 py-2 mb-8">
            <div className="w-2 h-2 bg-gold rounded-full animate-pulse" />
            <span className="text-white/90 font-sans text-sm font-medium">Limited scheduling availability — book your estimate today</span>
          </div>
        )}

        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-bold leading-tight mb-5">
          {heading}
        </h2>
        <p className="font-sans text-lg text-white/70 leading-relaxed mb-10 max-w-xl mx-auto">
          {subtext}
        </p>

        {/* Trust Row */}
        <div className="flex flex-wrap justify-center gap-5 mb-10">
          {['Licensed & Insured', '5-Star Rated', 'Free Estimates', '500+ Projects'].map((item) => (
            <div key={item} className="flex items-center gap-2 text-sm text-white/70 font-sans">
              <i className="ri-check-line text-gold" />
              {item}
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onEstimateClick}
            className="flex items-center justify-center gap-2.5 px-10 py-4 bg-gold text-walnut font-bold rounded-xl hover:bg-gold-dark transition-all text-base whitespace-nowrap"
          >
            <i className="ri-file-list-3-line" />
            Get a Free Estimate
          </button>
          <a
            href="tel:+14105550192"
            className="flex items-center justify-center gap-2.5 px-10 py-4 border-2 border-white/35 text-white font-semibold rounded-xl hover:bg-white/10 transition-all text-base whitespace-nowrap"
          >
            <i className="ri-phone-fill" />
            (410) 555-0192
          </a>
        </div>
      </div>
    </section>
  );
}
